import React from 'react';

function SoftSkills () {
    //en español
    // return (
    //     <div className="container px-4 py-5" id="softskills-section">
    //         <h2 className="display-5 fw-bold work">Soft Skills</h2>
    //         <hr className="featurette-divider"></hr>

    //         <div className="row row-cols-1 row-cols-md-2 g-4 py-5">
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Adaptabilidad</h3>
    //                 <p>Tengo una gran capacidad de aprendizaje y me adapto rápidamente a los nuevos desafíos.</p>
    //             </div>
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Perseverancia</h3>
    //                 <p>Me considero una persona perseverante, con ganas de crecer y mejorar como desarrolladora.</p>
    //             </div>
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Comunicación y Negociación</h3>
    //                 <p>Poseo excelentes habilidades de comunicación y negociación, lo que me permite colaborar en equipo y entregar resultados de calidad en tiempo y forma.</p>
    //             </div>
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Trabajo en Equipo</h3>
    //                 <p>Experiencia en trabajar en equipo y colaborar en proyectos grupales.</p>
    //             </div>
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Liderazgo</h3>
    //                 <p>Tengo habilidades de liderazgo para guiar y motivar a equipos en la consecución de objetivos comunes.</p>
    //             </div>
    //             <div className="col">
    //                 <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Formación y Enseñanza</h3>
    //                 <p>Tengo experiencia en formar y enseñar a empleados nuevos y compañeras del bootcamp, demostrando paciencia y empatía para facilitar su aprendizaje.</p>
    //             </div>

    //         </div>

    //     </div>
    // );
    return (
        <div className="container px-4 py-5" id="softskills-section">
            <h2 className="display-5 fw-bold work">Soft Skills</h2>
            <hr className="featurette-divider"></hr>

            <div className="row row-cols-1 row-cols-md-2 g-4 py-5">
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Adaptability</h3>
                    <p>I have a great capacity for learning and I adapt quickly to new challenges.</p>
                </div>
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Perseverance</h3>
                    <p>I consider myself a perseverant person, eager to grow and improve as a developer.</p>
                </div>
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Communication and Negotiation</h3>
                    <p>I possess excellent communication and negotiation skills, enabling me to collaborate in teams and deliver quality results in a timely manner.</p>
                </div>
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Teamwork</h3>
                    <p>Experience in working as part of a team and collaborating on group projects.</p>
                </div>
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Leadership</h3>
                    <p>I have leadership skills to guide and motivate teams in achieving common goals.</p>
                </div>
                <div className="col">
                    <h3 className="fw-bold mb-0 fs-4 text-body-emphasis">Training and Teaching</h3>
                    <p>I have experience in training and teaching new employees and bootcamp colleagues, demonstrating patience and empathy to facilitate their learning.</p>
                </div>

            </div>

        </div>
    );
};


export default SoftSkills;

